import * as React from 'react'
import { createContainer } from 'unstated-next'

import { EmbroideryVariant } from '../../types/graphql'

import { EmbroideryItemCustomProperties } from './types'

interface EmbroideryCartOption {
  id: string
  valid: boolean
  embroideryItemVariant: EmbroideryVariant
  embroideryLineItemProperties: EmbroideryItemCustomProperties
  embroiderySetupVariant?: EmbroideryVariant
}

function useKitEmbroidery() {
  const [embroideryCartOptions, setEmbroideryCartOptions] = React.useState<EmbroideryCartOption[]>(
    []
  )

  const getEmbroideryCartOption = (id: string) => {
    return embroideryCartOptions.find(item => item.id == id)
  }

  const removeEmbroideryCartOption = (id: string) => {
    setEmbroideryCartOptions(embroideryCartOptions.filter(item => item.id != id))
  }

  const updateEmbroideryCartOption = (newOption: EmbroideryCartOption) => {
    if (!embroideryCartOptions.includes(newOption)) {
      setEmbroideryCartOptions([...embroideryCartOptions, newOption])
    } else {
      setEmbroideryCartOptions(x => x.map(o => (o.id === newOption.id ? newOption : o)))
    }
  }

  // get a unique id for the current set of embroidery options,
  // this is used to keep 2 instances of the same kit(one with embroidery and one without)
  // as separate visual groups in the minicart
  const getEmbroideryId = () => {
    return embroideryCartOptions
      .map(o => o.embroideryLineItemProperties._embroideryId)
      .sort()
      .join()
  }

  return {
    embroideryCartOptions,
    setEmbroideryCartOptions,
    updateEmbroideryCartOption,
    removeEmbroideryCartOption,
    getEmbroideryCartOption,
    getEmbroideryId,
  }
}

export const KitEmbroideryService = createContainer(useKitEmbroidery)
